import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import BoxShadow from "../../../../Common/Components/BoxShadow";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { ToDateJalali } from "../../../../Common/Function";

function Table({
  title,
  form,
  data,
  col,
  to,
  lastText,
  textEmpty,
  modal,
  limit,
  withOutShadow,
  noShadow,
  noHeader,
  btn = {},
}) {
  const [state, setstate] = useState({
    reserve: false,
    pay: false,
    id: "",
  });

  const checkEmpty = data => {
    switch (data) {
      case null:
      case undefined:
      case "":
        return false;

      default:
        return true;
    }
  };

  return (
    <div className={col}>
      <BoxShadow
        className={`justify-content-center  px-3 down-table `}
        style={{
          padding: "0",
          margin: "0",
        }}
      >
        {!noHeader && (
          <div className="py-3">
            <h5 className="pt-2 d-flex align-items-center mb-0 mt-1">
              <img
                src={window.origin + "/img/order.png"}
                alt=""
                style={{
                  width: "50px",
                  height: "50px",
                }}
              />
              <span className="h6 mb-0 font-weight-bold mx-2  ">{title}</span>
            </h5>
          </div>
        )}

        <div
          className="table-responsive"
          style={{
            borderRadius: "10px",
          }}
        >
          <table className="table table-hover text-center">
            <thead className="table-gradiant border-top border-bottom head ">
              <tr className="h6 mb-0">
                {form &&
                  form.map((th, key) => (
                    <th
                      key={key}
                      style={{
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {th.name}
                    </th>
                  ))}
                {modal &&
                  modal.map((th, key) => (
                    <th
                      key={key}
                      style={{
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                      className="th-table"
                    >
                      {th.title}
                    </th>
                  ))}
                {btn && btn.text && (
                  <th
                    style={{
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="th-table"
                  ></th>
                )}
              </tr>
            </thead>
            <tbody>
              {checkEmpty(data) ? (
                data.map((tr, i) => {
                  if (i < (limit ? limit : 5)) {
                    return (
                      <Fragment key={i}>
                        <tr style={noHeader && { height: "30px" }}>
                          {form &&
                            form.map(i => {
                              if ("enum" in i) {
                                if ("objkey" in i) {
                                  return (
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {i.enum[tr[i.objkey][i.key]]
                                        ? i.enum[tr[i.objkey][i.key]]
                                        : "ثبت نشده"}
                                    </td>
                                  );
                                }
                                return (
                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {i.enum[tr[i.key]]
                                      ? i.enum[tr[i.key]]
                                      : "ثبت نشده"}
                                  </td>
                                );
                              }
                              if ("objkey" in i) {
                                return (
                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {tr && tr[i.objkey] && tr[i.objkey][i.key]
                                      ? tr[i.objkey] && tr[i.objkey][i.key]
                                      : "ثبت نشده"}
                                  </td>
                                );
                              }
                              if ("condition" in i) {
                                return (
                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {tr[i.condition] == "reserve"
                                      ? tr &&
                                        tr[i.objkey1] &&
                                        tr[i.objkey1][i.key]
                                        ? tr[i.objkey1] && tr[i.objkey1][i.key]
                                        : "ثبت نشده"
                                      : tr &&
                                        tr[i.objkey2] &&
                                        tr[i.objkey2][i.key]
                                      ? tr[i.objkey2] && tr[i.objkey2][i.key]
                                      : "ثبت نشده"}
                                  </td>
                                );
                              }
                              if ("format" in i) {
                                if (i.format === "date") {
                                  return (
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {ToDateJalali(tr[i.key])}
                                    </td>
                                  );
                                }
                              } else {
                                return (
                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {tr[i.key]}
                                  </td>
                                );
                              }
                            })}
                          {modal &&
                            modal.map((modal, key) => (
                              <td key={key}>
                                <button
                                  className=" btn s-button rounded-3  mt-3 mb-3 mx-1"
                                  onClick={() =>
                                    setstate({
                                      ...state,
                                      [modal.key]: tr.id,
                                    })
                                  }
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <img
                                    width={20}
                                    height={20}
                                    className="option-img"
                                    src={window.origin + "/img/more-ickon.png"}
                                  />
                                </button>
                              </td>
                            ))}
                          {btn && btn.text && (
                            <td>
                              <button
                                className=" btn  btn-success s-button rounded-3  mt-3 mb-3 mx-1"
                                onClick={() => btn.metod(tr)}
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                                disabled={btn.loading}
                              >
                                {btn.loading ? "در حال پردازش" : btn.text}
                              </button>
                            </td>
                          )}
                        </tr>
                      </Fragment>
                    );
                  }
                })
              ) : (
                <tr className="text-center">
                  <td colSpan={10}>
                    <img
                      width={128}
                      height={128}
                      src={window.origin + "/img/money.png"}
                    />
                    <h6 className="text-center card-title-dashboard">
                      {textEmpty}
                    </h6>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {checkEmpty(data) && lastText ? (
          <Link
            to={to}
            className="btn-more d-flex align-item-center justify-content-center reserv"
          >
            <div className=" btn btn-orange s-button rounded-3 px-5 mt-3 mb-3">
              {lastText}
            </div>
          </Link>
        ) : (
          ""
        )}
      </BoxShadow>

      {modal &&
        modal.map((modal, key) => (
          <CustomModal
            key={key}
            show={state[modal.key]}
            handleClose={() => setstate({ ...state, [modal.key]: false })}
            header={modal.title}
          >
            <modal.component
              id={state[modal.key]}
              data={
                data && data.filter(element => element.id == state[modal.key])
              }
            />
          </CustomModal>
        ))}
    </div>
  );
}

export default Table;
